import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import store from "@/store";
import defaultLayout from "@/layouts/defaultLayout.vue";
import onBoardLayout from "@/layouts/onBoardLayout.vue"
import onboarding from "@/views/onboarding.vue"
import organisations from "@/views/organisations.vue";
import organisationUserActivity from "@/views/organisationUserActivity.vue";
import startOnBoard from "@/views/startOnBoard.vue";
import processOnBoard from '@/views/processOnBoard.vue'
import finishOnBoard from '@/views/finishOnBoard.vue';
import systemsPage from '@/views/systems.vue'
import teams from "@/views/teams.vue";
import activities from '@/views/activities.vue'
import vendorsPage from '@/views/vendors.vue'
import frameworksPage from '@/views/frameworks.vue'
import users from '@/views/users.vue'
import completeonBoard from "@/views/completeonBoard.vue";
import onBoardActivitiesInfo from "@/views/onBoardActivitiesInfo.vue";
import onBoardSystemInformation from "@/views/onBoardSystemInformation.vue";
import driveUploader from "@/views/driverUploader.vue";
const routes: Array<RouteRecordRaw> = [
    {
        path: "/start/onboard",
        name: "start-onBoard",
        meta: {
            title: "Join Us",
            layout: onBoardLayout,
        },
        component: startOnBoard,
    },
    {
        path: "/drive",
        name: "drive",
        meta: {
            title: "Join Us",
            layout: defaultLayout,
        },
        component: driveUploader,
    },
    {
        path: "/process/onboard",
        name: "process-onBoard",
        meta: {
            title: "Join Us",
            layout: onBoardLayout,
        },
        component: processOnBoard,
    },
    {
        path: "/finish/onboard",
        name: "finish-onBoard",
        meta: {
            title: "Join Us",
            layout: onBoardLayout,
        },
        component: finishOnBoard,
    },
    {
        path: "/complete/onboard",
        name: "complete-onBoard",
        meta: {
            title: "Join Us",
            layout: onBoardLayout,
        },
        component: completeonBoard,
    },
    {
        path: "/activities",
        name: "activities",
        meta: {
            title: "Activities",
            layout: defaultLayout,
        },
        component: activities,
    },
    {
        path: "/users",
        name: "users",
        meta: {
            title: "Users",
            layout: defaultLayout,
        },
        component: users,
    },
    {
        path: "/teams",
        name: "teams",
        meta: {
            title: "Teams",
            layout: defaultLayout,
        },
        component: teams,
    },
    {
        path: "/systems/:systemId/onBoardSystemInformation",
        name: "onBoardSystemInformation",
        meta: {
            title: "Systems",
            layout: defaultLayout,
        },
        component: onBoardSystemInformation,
    },
    {
        path: "/activities/:activityId/onBoardActivitiesInfo",
        name: "onBoardActivitiesInfo",
        meta: {
            title: "Activities",
            layout: defaultLayout,
        },
        component: onBoardActivitiesInfo,
    },
    {
        path: "/organisation/add",
        name: "add-organisation",
        meta: {
            title: "Organisations",
            layout: defaultLayout,
        },
        component: onboarding,
    },
    {
        path: "/organisation/:organisationId?/edit",
        name: "edit-organisation",
        meta: {
            title: "Organisations",
            layout: defaultLayout,
        },
        component: onboarding,
    },
    {
        path: "/organisations",
        name: "organisations",
        meta: {
            title: "Organisations",
            layout: defaultLayout,
        },
        component: organisations,
    },
    {
        path: "/vendors",
        name: "vendors",
        meta: {
            title: "Vendors",
            layout: defaultLayout,
        },
        component: vendorsPage,
    },
    {
        path: "/frameworks",
        name: "frameworks",
        meta: {
            title: "Frameworks",
            layout: defaultLayout,
        },
        component: frameworksPage,
    },
    {
        path: "/systems",
        name: "systems",
        meta: {
            title: "Systems",
            layout: defaultLayout,
        },
        component: systemsPage,
    },
    {
        path: "/admin",
        name: "admin",
        redirect:'/organisations'
    },
    {
        path: "/organisationsactivity",
        name: "organisationsactivity",
        meta: {
            title: "Organisation User Activity",
            layout: defaultLayout,
        },
        component: organisationUserActivity,
    },
    {
        path: "/",
        name: "home",
        redirect:'/organisations'
    },
    {
        path: '/error',
        name: 'error',
        meta: {
            title: 'error',
            layout: 'empty-layout',
        },
        props:true,
        component: () => import('@/components/error.vue')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: '/error',
    },

]
const router = createRouter({
    history: createWebHistory('/'),
    routes,
});
 
 
 
// router.beforeEach(async (to, from, next) => {
//     document.title=`Admin- ${to.meta.title}`
//     store.state.isLoading = true;
//     // next()
//     // if (to.path == '/org/dashboard' || to.path == '/admin' || to.path == '/admin/courses/getall' || to.path == '/') {
//         if (to.query.session) {
//             localStorage.setItem('AUTH_ID', to.query.session.toString());
//             await store.dispatch('getUserInfo').then((res) => {
//                 if (!res.data[0]) window.location.href = `${process.env.VUE_APP_AUTH_WEBAPP_URL}/session?returnTo=${process.env.VUE_APP_ADMIN_UI}`;
//                 else {
//                     next();
//                 }
//             })
//         }
//         normalAuthenticationCheck(next);
//     // } else {
//     //     normalAuthenticationCheck(next);
//     // }
// });
router.beforeEach(async (to, from, next) => {
    document.title = `Admin - ${to.meta.title || ''}`;
    store.state.isLoading = true;
    if (to.query.session) {
        localStorage.setItem('AUTH_ID', to.query.session.toString());
        try {
            const res = await store.dispatch('getUserInfo');
            const user = res.data[0];
            // console.log('user details',user);         
            if(user && user.organisationType==10702){
            //    router.push({ name: 'error'})
                next({ name: "error", query: { code: 403 }});
                return;
            }
            else if (!user) {
                // window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_ADMIN_UI}`;
                next({ name: "error", query: { code: 401 }});
                return;
            }
             else if (user && user.organisationType==10701 && user.isSuperUser==false) {
                next({ name: "error", query: { code: 401 }});
                // window.location.href = `${process.env.VUE_APP_ADMIN_UI}/error?code=${401}`;
                return;
            }
            if(to.path === '/organisations'){
                return next('/organisations')
            }
            return next();
        } catch (err) {
            // window.location.href = `${process.env.VUE_APP_ADMIN_UI}/error?code=${401}`;
            next({ name: "error", query: { code: 401 }});
            return;
        }
    }
    return normalAuthenticationCheck(next);
});
router.afterEach(async (to, from, next) => {
    store.state.isLoading = false
});
async function normalAuthenticationCheck(next: any) {
    // console.log('Next Function');
    if (!localStorage.getItem('AUTH_ID')) {
        // console.log('Auth_ID not exists');
        window.location.href = `${process.env.VUE_APP_AUTH_UI}/session?returnTo=${process.env.VUE_APP_ADMIN_UI}`;
    } else {
        // console.log('Auth_ID Exists');
        const userInfo = store.getters.userInfo;
        // console.log('userInfo',userInfo);
        if (!userInfo.roles) {
            // console.log('Entered 2nd if');  
            await store.dispatch('getUserInfo').then((res) => {
                const user = res.data[0];
                if(user && user.organisationType==10702){
                    // console.log('Entered if condition');
                    next({ name: "error", query: { code: 403 }});
                    return;
                }
                else if (user && user.organisationType==10701 && user.isSuperUser==false) {
                    // window.location.href = `${process.env.VUE_APP_ADMIN_UI}/error?code=${401}`;
                    next({ name: "error", query: { code: 401 }});
                    return;
                }
                next();
            });
        }
        else {
            // console.log('Entered Else!!');
            
            next();
        }
    }
}


export default router;